<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <span class="title">Exchange</span>
      <span class="subtitle">{{ 'BACKOFFICE' | translate }}</span>
    </a>
  </div>
</div>

<div class="header-container"><nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
  <nb-option *ngFor="let theme of themes" [value]="theme.value">
    &nbsp;{{ theme.name }}
  </nb-option>
</nb-select>
  <nb-select [selected]="translateService.currentLang"
             (selectedChange)="translateService.use($event)"
             status="info"
             class="pl-2">
    <nb-option *ngFor="let lang of translateService.getLangs()" [value]="lang">
      &nbsp;{{ lang | uppercase}}
    </nb-option>
  </nb-select>
  <nb-actions size="small">
    <nb-action>
      <nb-user *ngIf="memberExist()"
               [nbContextMenu]="userMenu"
               [name]="memberFullName"
               [onlyPicture]="userPictureOnly"
               [picture]="member?.picture"></nb-user>
    </nb-action>
  </nb-actions>
</div>
